import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { WarehouseService } from '../services/warehouse.service';
import { Warehouse } from '../models/warehouse.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'warehouse',
  templateUrl: '../views/products/warehouse.html',
  providers: [WarehouseService]
})
export class WarehouseComponent{
  public title: string;
  public warehouses: Warehouse[];
  public submitWarehouseModel: Warehouse;
  public message: any;
  public mode: string;
  public privileges: Privileges[];
  public warehousePrivilege:number;
  public wait:boolean;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private warehouseService: WarehouseService,
    public sharedVariables: VariableService
  )
  {
      this.title = null;
      this.mode = "submit-add";
      this.submitWarehouseModel = new Warehouse(0,'','');
      this.warehousePrivilege = null;
      this.wait = true;
  }

  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.warehousePrivilege == 1){
                                    this.getAllWarehouses();
                                    this.wait = false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait = false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllWarehouses()
  {
    this.warehouseService.getWarehouses().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.warehouses = result.data;
          console.log(this.warehouses);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }


  onSubmit()
  {
    if(this.mode == "submit-add")
    {
      this.saveWarehouse();
    }else{
      this.updateWarehouse();
    }

    this.mode = "submit-add";
    setTimeout(()=> {
                      this.message = null;
                    },this.sharedVariables.timeMessage);
    setTimeout(()=> {
                      this.getAllWarehouses();
                      this.submitWarehouseModel = new Warehouse(0,'','');
                    },this.sharedVariables.timeToLoad);
    console.log("mode",this.mode);
  }

  saveWarehouse()
  {
    this.warehouseService.addWarehouse(this.submitWarehouseModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  cleanObject()
  {
    this.submitWarehouseModel = new Warehouse(0,'','');
  }
  editWarehouse(pWarehouse: Warehouse)
  {
    this.mode = "submit-update";
    this.submitWarehouseModel = Object.assign({}, pWarehouse);

    console.log("Checkout objects");
    console.log("mode ",this.mode);
  }

  updateWarehouse()
  {
      let id = this.submitWarehouseModel.ID;
      console.log("objeto update ",this.submitWarehouseModel);
      this.warehouseService.updateWarehouse(id,this.submitWarehouseModel).subscribe(
        response => {
          if(response.code == 200)
          {
            this.message = response.data;
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
  }

  deleteWarehouse(id: number)
  {
    this.warehouseService.deleteWarehouse(id).subscribe(
        response => {
          if(response.code == 200){
            this.getAllWarehouses();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.warehousePrivilege = response.data[0].warehouse;
            console.log("Privilegios del usuario",this.warehousePrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/warehouse.component.ts